import { amplitudeEvent } from '@services/amplitudeHelper';
import {
  VISIT_ATO_BUY_PAGE,
  CLICK_BUY_BUTTON_CONFIRM,
  CLICK_SELL_BUTTON_CONFIRM,
  CLICK_BUY_BUTTON,
  VISIT_ATO_SELL_PAGE,
  CLICK_SELL_BUTTON,
  CLICK_BUY_ATO,
  CLICK_SUBMIT_BUY_BUTTON,
  CLICK_SELL_ATO,
  CLICK_SUBMIT_SELL_BUTTON,
  CLICK_STOCK_DETAIL_PAGE,
  CLICK_TOP_UP_BUTTON,
} from '@services/trackerConst';

export const buyProps = {
  'entry point': 'regular buy page',
};

const sellProps = {
  'entry point': 'regular sell page',
};
export const eventClickVisitAtoBuy = (props) => {
  amplitudeEvent(VISIT_ATO_BUY_PAGE, { ...buyProps, ...props });
};

export const eventClickBuyConfirm = (props) => {
  amplitudeEvent(CLICK_BUY_BUTTON_CONFIRM, props);
};

export const eventClickSellConfirm = (props) => {
  amplitudeEvent(CLICK_SELL_BUTTON_CONFIRM, props);
};

export const eventClickBuyButton = (props) => {
  amplitudeEvent(CLICK_BUY_BUTTON, { ...buyProps, ...props });
};

export const eventClickVisitAtoSell = (props) => {
  amplitudeEvent(VISIT_ATO_SELL_PAGE, { ...sellProps, ...props });
};

export const eventClickSellButton = (props) => {
  amplitudeEvent(CLICK_SELL_BUTTON, { ...sellProps, ...props });
};

export const eventClickBuyAto = (props) => {
  amplitudeEvent(CLICK_BUY_ATO, props);
};

export const eventClickSubmitBuy = () => {
  amplitudeEvent(CLICK_SUBMIT_BUY_BUTTON);
};

export const eventClickSellAto = (props) => {
  amplitudeEvent(CLICK_SELL_ATO, props);
};

export const eventClickSubmitSell = () => {
  amplitudeEvent(CLICK_SUBMIT_SELL_BUTTON);
};

export const eventClickDetailPageStock = (props) => {
  amplitudeEvent(CLICK_STOCK_DETAIL_PAGE, props);
};

// export const eventClickDeleteWatchlistStock = () => {
//   amplitudeEvent(CLICK_DELETE_WATCHLIST_STOCK_ENTRY);
// };

// export const eventClickAddWatchlistStock = (props) => {
//   amplitudeEvent(CLICK_ADD_STOCK_TO_WATCHLIST, props);
// };

export const eventClickTopUp = () => {
  amplitudeEvent(CLICK_TOP_UP_BUTTON, buyProps);
};
